import { render, staticRenderFns } from "./ModalPreferences.vue?vue&type=template&id=72a0e625&scoped=true&"
import script from "./ModalPreferences.vue?vue&type=script&lang=js&"
export * from "./ModalPreferences.vue?vue&type=script&lang=js&"
import style0 from "./ModalPreferences.vue?vue&type=style&index=0&id=72a0e625&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0e625",
  null
  
)

export default component.exports